/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  MutationKey,
  useMutation,
  UseMutationResult,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { userSessionIssuersUpdate } from "../funcs/userSessionIssuersUpdate.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { UserSessionIssuer } from "../models/components/usersessionissuer.js";
import { GramError } from "../models/errors/gramerror.js";
import {
  ConnectionError,
  InvalidRequestError,
  RequestAbortedError,
  RequestTimeoutError,
  UnexpectedClientError,
} from "../models/errors/httpclienterrors.js";
import { ResponseValidationError } from "../models/errors/responsevalidationerror.js";
import { SDKValidationError } from "../models/errors/sdkvalidationerror.js";
import { ServiceError } from "../models/errors/serviceerror.js";
import {
  UpdateUserSessionIssuerRequest,
  UpdateUserSessionIssuerSecurity,
} from "../models/operations/updateusersessionissuer.js";
import { unwrapAsync } from "../types/fp.js";
import { useGramContext } from "./_context.js";
import { MutationHookOptions } from "./_types.js";

export type UpdateUserSessionIssuerMutationVariables = {
  request: UpdateUserSessionIssuerRequest;
  security?: UpdateUserSessionIssuerSecurity | undefined;
  options?: RequestOptions;
};

export type UpdateUserSessionIssuerMutationData = UserSessionIssuer;

export type UpdateUserSessionIssuerMutationError =
  | ServiceError
  | GramError
  | ResponseValidationError
  | ConnectionError
  | RequestAbortedError
  | RequestTimeoutError
  | InvalidRequestError
  | UnexpectedClientError
  | SDKValidationError;

/**
 * updateUserSessionIssuer userSessionIssuers
 *
 * @remarks
 * Update fields on an existing user_session_issuer.
 */
export function useUpdateUserSessionIssuerMutation(
  options?: MutationHookOptions<
    UpdateUserSessionIssuerMutationData,
    UpdateUserSessionIssuerMutationError,
    UpdateUserSessionIssuerMutationVariables
  >,
): UseMutationResult<
  UpdateUserSessionIssuerMutationData,
  UpdateUserSessionIssuerMutationError,
  UpdateUserSessionIssuerMutationVariables
> {
  const client = useGramContext();
  return useMutation({
    ...buildUpdateUserSessionIssuerMutation(client, options),
    ...options,
  });
}

export function mutationKeyUpdateUserSessionIssuer(): MutationKey {
  return ["@gram/client", "userSessionIssuers", "update"];
}

export function buildUpdateUserSessionIssuerMutation(
  client$: GramCore,
  hookOptions?: RequestOptions,
): {
  mutationKey: MutationKey;
  mutationFn: (
    variables: UpdateUserSessionIssuerMutationVariables,
  ) => Promise<UpdateUserSessionIssuerMutationData>;
} {
  return {
    mutationKey: mutationKeyUpdateUserSessionIssuer(),
    mutationFn: function updateUserSessionIssuerMutationFn({
      request,
      security,
      options,
    }): Promise<UpdateUserSessionIssuerMutationData> {
      const mergedOptions = {
        ...hookOptions,
        ...options,
        fetchOptions: {
          ...hookOptions?.fetchOptions,
          ...options?.fetchOptions,
          signal: combineSignals(
            hookOptions?.fetchOptions?.signal,
            options?.fetchOptions?.signal,
          ),
        },
      };
      return unwrapAsync(userSessionIssuersUpdate(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}
